<template>
  <div class="p-4 rounded bg-secondary-3 my-3">
    <icon-view
      :has-border="false"
      icon="fas fa-calendar-edit text-orange mb-1"
      icon-size="14px"
      title=" Documentación de fecha de realizado"
      variant="custom-icon-view"
      icon-background="white"
    />
    <validation-observer ref="services-documentation">
      <div class="row my-3">
        <div class="col-12 col-md-3">
          <div class="color-secondary-6 font-14 mb-1">
            Fecha:
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-date-picker
              placeholder="Seleccione"
              class="custom-datetime-picker-container"
              container-class="w-100"
              custom-error-msg="La fecha es requerida"
              :disabled="isReadOnly"
              v-model="model.date"
              :max-date="minDate"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-3 mt-md-0 mt-3">
          <div class="color-secondary-6 font-14 mb-1">
            Método:
          </div>
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-drop-down
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              custom-error-msg="El método es requerido"
              :disabled="isReadOnly"
              v-model="model.method"
              :options="methods"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 mt-3">
          <div class="color-secondary-6 font-14 mb-1">
            Comentario:
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              placeholder="Escribe un comentario"
              :disabled="isReadOnly"
              v-model="model.comment"
              :maxlength="3000"
              :error="errors[0]"
              custom-error-msg="El comentario es requerido"
            />
          </validation-provider>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-x-1">
        <action-button
          variant="outline-danger"
          i="fas fa-times-circle"
          @click="cancel"
        >
          Cancelar
        </action-button>
        <action-button
          v-if="!isReadOnly"
          variant="success"
          type="button"
          i="fas fa-save"
          @click="save"
        >
          Guardar
        </action-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'ReferralServiceDocumentation',
  components: {
    IconView,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    methods: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data() {
    return {
      model: {
        date: null,
        method: null,
        comment: null,
      },
    };
  },
  computed: {
    minDate() {
      return new Date();
    },
    isReadOnly() {
      return Boolean(this.data);
    },
  },
  mounted() {
    this.model = {
      date: this.data.date,
      method: this.methods.find((m) => m.id === this.data.methodId),
      comment: this.data.comment,
    };
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    async save() {
      const valid = await this.$refs['services-documentation']?.validate();
      if (!valid) return;
      this.$emit('save', {
        date: this.model.date,
        method: this.model.method?.id,
        comment: this.model.comment,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gap-x-1 {
  gap: 0px 10px;
}
::v-deep {
  .custom-datetime-picker-container.width-container,
  .custom-time-picker-container.width-container {
    width: 100% !important;
  }
}
</style>
